/**
 * Локализованные сообщения валидации (русский)
 */
import type { ValidationRule } from '@vuelidate/core';

import { helpers } from '@vuelidate/validators';

export const validationMessages = {
  required: 'Поле обязательно для заполнения',
  phone: 'Введите корректный номер телефона',
  minLength: (min: number) => `Минимальная длина: ${min} символов`,
  maxLength: (max: number) => `Максимальная длина: ${max} символов`,
  numeric: 'Поле должно содержать только цифры',
};

/**
 * Обёртка для привязки пользовательского сообщения к правилу Vuelidate.
 */
export function withMessage<T extends ValidationRule>(message: string, rule: T): T {
  return helpers.withMessage(message, rule) as T;
}
